import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { adminFetch, setAdminSessionToken } from "../services/adminClient";

const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  /** Remove legacy key that may linger from older sessions. */
  useEffect(() => {
    try {
      localStorage.removeItem("adminToken");
    } catch {
      /* ignore */
    }
  }, []);

  /** Hit GET /api/admin/me — session is HttpOnly cookie (not localStorage). */
  const refreshSession = useCallback(async () => {
    setChecking(true);
    try {
      const res = await adminFetch("me");
      if (!res.ok) {
        setAdmin(null);
        return;
      }
      const data = await res.json();
      if (data?.role === "admin") setAdmin({ role: "admin" });
      else setAdmin(null);
    } catch {
      setAdmin(null);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    refreshSession();
  }, [refreshSession]);

  const loginSucceeded = useCallback(() => {
    setAdmin({ role: "admin" });
  }, []);

  const logout = useCallback(async () => {
    try {
      await adminFetch("logout", { method: "POST" });
    } catch {
      /* cookie may already be expired */
    }
    setAdminSessionToken(null); // clear Bearer fallback token
    setAdmin(null);
  }, []);

  return (
    <AdminAuthContext.Provider
      value={{
        admin,
        checking,
        loginSucceeded,
        logout,
        refreshSession,
      }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
